import $ from 'jquery';
import { CP_TYPE_YOUTUBE, CP_TYPE_KAKAOTV } from '../cp-meta/types';


/**
 *
 * @param {s2LogData}  nextClip
 * @param {Clip}  nowPlaying
 * @returns {string}
 */
function makeLogURL(nextClip, nowPlaying) {
  const { dsid, s2Id, cpType, clipId } = nextClip;
  const isYoutube = cpType === CP_TYPE_YOUTUBE;
  const isKakao = cpType === CP_TYPE_KAKAOTV;

  return SF.getQsUrl({
    w: 'vclip',
    uuid  : window.uuid,
    m     : 'ft_proxy',
    q     : '',
    id    : isYoutube ? dsid : clipId,
    source: isYoutube ? nowPlaying.dsid : nowPlaying.clipId,
    s2Id,
    type  : isYoutube ? 'ytlog' :
            isKakao ? 'tvlog' : cpType
  }, 1);
}

/**
 *
 * @param {s2LogData} nextClip
 * @param {Clip} nowPlaying
 */
export function sendS2Log(nextClip, nowPlaying) {
  if (!nextClip.s2Id) {
    return;
  }

  const url = makeLogURL(nextClip, nowPlaying);

  $.ajax({ contentType: 'text/html', url });
}

/**
 *
 * @typedef {Object} s2LogData
 * @property {PlaylistItem.dsid|string} dsid
 * @property {PlaylistItem.videoId|string} videoId
 * @property {PlayListAPI.s2Id|string} s2Id
 * @property {PlaylistItem.cpType|string} cpType
 */



/** WEBPACK FOOTER **
 ** ./src/VO2/libs/logger/s2-log.js
 **/